import { render, staticRenderFns } from "./CameraDialogExam.vue?vue&type=template&id=c6d5d940&scoped=true"
import script from "./CameraDialogExam.vue?vue&type=script&lang=js"
export * from "./CameraDialogExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d5d940",
  null
  
)

export default component.exports